<template>
  <div id="app">
    <Header />
    <mq-layout mq="lg+">
      <Top />
      <Inhalt />
      <Zitate />
      <Clip />
      <Gallerie />
      <Team />
      <BasePicture image="allgemein/pic01.jpg" />
    </mq-layout>
    <mq-layout :mq="['sm', 'md']">
      <Mobile />
    </mq-layout>
    <Footer />
    <BaseYoutube :youtube="$config.youtube" :margin="100" />
    <BaseYoutube :youtube="$config.youtube2" :margin="100" :number="2" />
    <BaseYoutube :youtube="$config.youtube3" :margin="100" :number="3" />
    <BaseYoutube :youtube="$config.youtube4" :margin="100" :number="4" />
  </div>
</template>

<script>
import Header from './website_elements/Header.vue'
import Top from './website_elements/Top.vue'
import Inhalt from './website_elements/Inhalt.vue'
import Zitate from './website_elements/Zitate.vue'
import Clip from './website_elements/Clip.vue'
import Gallerie from './website_elements/Gallerie.vue'
import Team from './website_elements/Team.vue'
import Mobile from './website_elements/Mobile.vue'
import Footer from './website_elements/Footer.vue'
import moment from 'moment'

export default {
  name: 'App',
  components: {
    Header,
    Top,
    Inhalt,
    Zitate,
    Clip,
    Gallerie,
    Team,
    Mobile,
    Footer,
  },
  /**
   * Provide the date in other components
   *
   * to get it in a component: inject: ['kinostart'],
   * see: BaseKinostart.vue
   */
  provide() {
    return {
      kinostart: this.kinostart,
      kinostart2: this.kinostart2,
    }
  },
  computed: {
    kinostart() {
      return moment() < moment(this.$config.release_line_1.date)
        ? this.$config.release_line_1.line_before
        : this.$config.release_line_1.line_after
    },
    kinostart2() {
      return moment() < moment(this.$config.release_line_2.date)
        ? this.$config.release_line_2.line_before
        : this.$config.release_line_2.line_after
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.$store.dispatch('Window/docElem', {
        tmp: window.document.documentElement,
      })
      window.addEventListener('resize', this.sendDispatch)
      this.$store.dispatch('Window/resize')
    })
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.$config.title,
      // all titles will be injected into this template
      titleTemplate: '%s | Offizielle Webseite',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$config.facebook.og_description,
        },
        {
          vmid: 'og:title',
          name: 'og:title',
          content: this.$config.title,
        },
        {
          vmid: 'og:description',
          name: 'og:description',
          content: this.$config.facebook.og_description,
        },
        {
          vmid: 'og:url',
          name: 'og:url',
          content: this.$config.url,
        },
        {
          vmid: 'og:type',
          name: 'og:type',
          content: 'website',
        },
        {
          vmid: 'og:image',
          name: 'og:image',
          content: `${this.$config.url}/${this.$config.facebook.og_image}`,
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$config.keywords,
        },
        {
          vmid: 'page-topic',
          name: 'page-topic',
          content: 'Medien',
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: 'index, follow',
        },
        {
          vmid: 'author',
          name: 'author',
          content: this.$config.verantwortlich,
        },
        {
          vmid: 'publisher',
          name: 'publisher',
          content: this.$config.verantwortlich,
        },
        {
          vmid: 'copyright',
          name: 'copyright',
          content: this.$config.verantwortlich,
        },
      ],
      link: [{ rel: 'icon', href: this.$config.favicon }],
    }
  },
}
</script>

<style lang="scss">
#app {
  margin-inline: auto;
  max-width: 2560px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
